export class Telefones
{
    id_fone: number = 0;
    numero_fone: string = '';
    obs_fone: string = '';
    id_pessoa: number = 0;
    alterado: string = '';
}